import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CommonService } from 'src/app-core/services/common.service';
import * as moment from 'moment';

@Component({
  selector: 'app-orders-breadcrumbs',
  templateUrl: './orders-breadcrumbs.component.html',
  styleUrls: ['./orders-breadcrumbs.component.scss']
})
export class OrdersBreadcrumbsComponent implements OnInit {
  @Output() emitOrdersStatus: EventEmitter<any> = new EventEmitter<any>();
  @Input() isJobForm: boolean;
  @Input() set orderDetails(orderDetails: any) {
    if (orderDetails && orderDetails.id) {
      this.statusId = orderDetails.statusId;
      this.orderId = orderDetails.id;
      this.isActive = orderDetails.isActive;
      this.getOrderStatus();
    }
  }
  orderId: number;
  statusId: number;
  breadcrumbs = [];
  isActive = true;

  constructor(
    private commonService: CommonService
  ) { }

  ngOnInit() {
    this.getOrderStatus();
  }

  getOrderStatus() {
    let queryString = `IsJob=${this.isJobForm}`;
    if (this.orderId) {
      queryString += `&OrderId=${this.orderId}`;
    }
    this.commonService.getOrderStatus(queryString).subscribe((response: any) => {
      this.breadcrumbs = response.data;
      this.breadcrumbs.map(status => {
        if (status.toolTip) {
          const splited = status.toolTip.split(' at'); // .map(value => value.trim());
          const dateValue = moment(splited[1]).format('MM/DD/YYYY HH:mm:ss');
          const convertedDate = new Date(Date.parse(dateValue + ' UTC'));
          if (splited[1].trim() === 'NA') {
            status.tooltipText = status.toolTip;
          } else {
            status.tooltipText = splited[0] + ' at ' + (moment(convertedDate).format('MM/DD/YYYY') + ' ' + moment(convertedDate).format('hh:mm A'));
          }
        }
      });
      this.emitOrdersStatus.emit();
    });
  }

}
